// eslint-disable-next-line import/prefer-default-export
export const spxx = {
  path: '/spxx',
  name: 'spxx',
  redirect: '/spxx/qbsp',
  component: () => import('../views/spxx/spxx.vue'),
  children: [
    {
      path: '/spxx/qbsp',
      name: 'spxx_qbsp',
      component: () => import('../views/spxx/qbsp.vue'),
    },
    {
      path: '/spxx/cpjs',
      name: 'spxx_cpjs',
      component: () => import('../views/spxx/cpjs.vue'),
    },
    {
      path: '/spxx/ztgl',
      name: 'spxx_ztgl',
      component: () => import('../views/spxx/ztgl.vue'),
    },
    {
      path: '/spxx/cssz',
      name: 'spxx_cssz',
      component: () => import('../views/spxx/cssz.vue'),
    },
    {
      path: '/spxx/fpgl',
      name: 'spxx_fpgl',
      component: () => import('../views/spxx/fpgl.vue'),
    },
    {
      path: '/spxx/pzcl',
      name: 'spxx_pzcl',
      component: () => import('../views/spxx/pzcl.vue'),
    },
    {
      path: '/spxx/zbcx',
      name: 'spxx_zbcx',
      component: () => import('../views/spxx/zbcx.vue'),
    },
    {
      path: '/spxx/cwbb',
      name: 'spxx_cwbb',
      component: () => import('../views/spxx/cwbb.vue'),
    },
    {
      path: '/spxx/qmcl',
      name: 'spxx_qmcl',
      component: () => import('../views/spxx/qmcl.vue'),
    },
    {
      path: '/spxx/nssb',
      name: 'spxx_nssb',
      component: () => import('../views/spxx/nssb.vue'),
    },
  ],
};
